import { apiClient } from "@/modules/shared/utils/apiClient";

import { ConfirmRescheduleData } from "../types/ConfirmRescheduleData";

export const confirmRescheduleRequest = (data: ConfirmRescheduleData) =>
  apiClient.post("/coaching-session/reschedule/confirm", data);
